<template>
  <div class="py-1">
    <div
      class="h-24 rounded border border-dashed relative text-gray-700 hover:text-gray-300 cursor-pointer text-xs"
      @mouseenter="dragOver"
      @mouseover="dragOver"
      @mouseleave="dragLeave"
      @dragover="dragOver"
      @dragleave="dragLeave"
      @mouseout="dragLeave"
    >
      <div
        class="text-center absolute w-full"
        style="top: 50%; transform: translate(0, -50%)"
      >
        <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
        <div v-html="i18n.label"></div>
        <slot></slot>
        <div v-html="i18n.mime" class="font-bold"></div>
        <div v-html="i18n.max" class="font-bold"></div>
      </div>
      <drag-overlay :dragging="dragging"></drag-overlay>
      <input
        class="absolute top-0 right-0 bottom-0 left-0 w-full h-full opacity-0 cursor-pointer"
        type="file"
        :required="required"
        multiple
        @change="onFileChange"
      />
    </div>
    <span class="help danger text-sm">
      <span
        v-if="$parent.form.errors.has('documents')"
        v-text="$parent.form.errors.get('documents')"
      ></span>
    </span>
    <div class="py-2 flex flex-col items-center justify-start flex-wrap">
      <file-to-upload
        v-for="(document, index) in chosenFiles"
        :file="document"
        :key="'documents.' + index"
        @remove="$emit('remove', index)"
        :error="error(index)"
        :closeLabel="i18n.remove_file_tooltip"
      />
    </div>
  </div>
</template>

<script>
import FileToUpload from "./Components/FileToUpload";

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    chosenFiles: {
      type: Array,
      required: false,
    },
    errors: {
      type: Object,
      required: false,
    },
    max: {
      type: Number,
      required: false,
      default: 3,
    },
  },
  components: { FileToUpload },
  mixins: [],
  data: function () {
    return {
      dragging: false,
    };
  },
  methods: {
    onFileChange(e) {
      this.dragging = false;

      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      Array.from(files).forEach((file) => {
        this.validateFile(file);
      });
    },

    dragOver() {
      this.dragging = true;
    },

    dragLeave() {
      this.dragging = false;
    },

    validateFile(file) {
      this.$emit("file-added", file);
    },

    error(index) {
      let error = "";
      let key = "documents." + index;
      if (hasOwnProperty(this.errors.errors, key)) {
        for (let i = 0; i < this.errors.errors[key].length; i++) {
          error += "<div>" + this.errors.errors[key][i] + "</div>";
        }

        return error;
      }

      if (this.chosenFiles.length > this.max && index > this.max - 1) {
        return this.i18n.max;
      }

      return "";
    },
  },
  computed: {},
  mounted() {},
};
</script>
